const appBaseUrl = '/app';
const secureRouteBuilder = (url: string) => appBaseUrl + url;

export { secureRouteBuilder };

// import * as React from 'react';
// import { Route, RouteComponentProps } from 'react-router-dom';
// import { SecureContext } from '@components';
// import { Location } from 'history';
// import { AuthMethods } from '../auth';

// export interface ISecureRouteOwnProps {
//     component?: React.FunctionComponent<{}> | React.ComponentClass<{}>;
//     path: string;
//     location?: Location;
//     render?: ((props: RouteComponentProps<{}>) => React.ReactNode);
//     children?: ((props: RouteComponentProps<{}>) => React.ReactNode | React.ReactNode);
//     strict?: boolean;
// }

// const SecureRoute: React.FunctionComponent<ISecureRouteOwnProps> =
//     (props) => {
//         const { path, component, ...rest } = props;
//         const Child = component;

//         const renderRoute = (routeProps: RouteComponentProps<{}>) => (
//             <SecureContext authMethods={AuthMethods}>
//                 <Child />
//             </SecureContext>
//         );

//         return (
//             <Route
//                 exact
//                 path={path}
//                 render={renderRoute}
//                 {...rest} />
//         );
//     };

// const appBaseUrl = '/app';
// const secureRouteBuilder = (url: string) => appBaseUrl + url;

// export default SecureRoute;
// export { appBaseUrl, secureRouteBuilder };
